import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, create, update, getList, setPaginaAtual } from './dataEspecialActions';
import PermissaoUsuario from '../auth/permissao';

import List from './dataEspecialList';
import Form from './dataEspecialForm';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';

class DataEspecial extends Component {
  componentWillMount() {
    this.props.init();
    this.changeControlador = this.changeControlador.bind(this);
  }

  changeControlador() {
    this.props.getList();
    this.props.setPaginaAtual(0);
    this.props.init();
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{
                      width: '180px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <SelectConfControlador
                    anel={false}
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{
                      width: '300px',
                      height: '38px',
                      padding: '7px 10px',
                      fontSize: '13px',
                      fontWeight: '500',
                      border: '1px solid #bfd0e0',
                      borderRadius: '10px',
                      backgroundColor: '#ffffff',
                      color: '#475569',
                      boxShadow: 'none',
                    }}
                  />
                </div>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout={true} />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form
                  onSubmit={this.props.update}
                  readOnly={false}
                  submitClass="primary"
                  submitLabel="Salvar"
                  premiumLayout={true}
                />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update, getList, setPaginaAtual }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(DataEspecial);
